invHdApp.controller('CustomerHistoryController', ['$scope', 'Order', 'CustomerOrder', '$location', '$filter', '$routeParams', '$rootScope', 'Analytic', '$translate', '$http',
    function ($scope, Order, CustomerOrder, $location, $filter, $routeParams, $rootScope, Analytic, $translate, $http) {

        $scope.filterProp = ['customers']; // Müşteri filtresini varsayılan olarak göster
        $scope.selectedItems = [];
        $scope.isEmpty = false;

        $scope.calculateTVS = function (order) {
            if (!order || !order.tvs || !order.tvs.date_str) {
                return '-';
            }
            return order.tvs.date_str;
        };

        // Initialize filterCustomers if not already defined
        if (typeof $rootScope.filterCustomers === 'undefined') {
            $rootScope.filterCustomers = [];
        }
        
        // Initialize searchRes for customer search
        $scope.searchRes = [];

        $scope.getCustomers = function () {
            // $rootScope.filterCustomers'ı güvenli bir şekilde tanımla
            if (typeof $rootScope.filterCustomers === 'undefined') {
                $rootScope.filterCustomers = [];
            }
            
            // Eğer zaten yüklenmişse tekrar yükleme
            if ($rootScope.filterCustomers && $rootScope.filterCustomers.length > 0) {
                return;
            }
            
            $http.get('api/filter/customers', {
                ignoreLoadingBar: true
            }).then(function (filterResponse) {
                let uniqueCustomers = {};
                
                if (filterResponse.data && filterResponse.data.customers) {
                    // customers zaten bir array, Object.values() kullanmaya gerek yok
                    filterResponse.data.customers.forEach(function(customer) {
                        if (customer.id) {
                            uniqueCustomers[customer.id] = customer;
                        }
                    });
                }

                $http.get('api/dashboard', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    if (response.data && response.data.orders && response.data.orders.data) {
                        response.data.orders.data.forEach(function(order) {
                            if (order.customer) {
                                uniqueCustomers[order.customer.id] = order.customer;
                            }
                        });
                    }
                    
                    $rootScope.filterCustomers = Object.values(uniqueCustomers).sort((a,b) => 
                        (a.customer_name || a.dba_name).localeCompare(b.customer_name || b.dba_name)
                    );

                    $('.selectpicker').selectpicker('refresh');
                }).catch(function(error) {
                    console.error('Dashboard API error:', error);
                    $rootScope.filterCustomers = [];
                });
            }).catch(function(error) {
                console.error('Filter customers API error:', error);
                $rootScope.filterCustomers = [];
            });
        };

        $scope.searchCustomer = function ($select, type) {
            if (type != lastType) $scope.searchRes = [];
            if ($select && $select.search) {
                return $http.get('api/find-customer', {
                    params: {
                        s: $select.search,
                        type: type
                    },
                    ignoreLoadingBar: true
                }).then(function (response) {
                    if (response && response.data && response.data.customers) {
                        $scope.searchRes = response.data.customers;
                    } else {
                        $scope.searchRes = [];
                    }
                }).catch(function(error) {
                    console.error('Customer search error:', error);
                    $scope.searchRes = [];
                });
                lastType = type;
            }
        };

        var lastType = '';

        // Initialize filter data arrays
        $rootScope.filterCities = [];
        $rootScope.filterDistricts = [];

        // Initialize date types
        $rootScope.dateTypes = [
            {
                'name': $translate.instant('SCHEDULED_TIME_TYPE'),
                'key': 'scheduled_time'
            },
            {
                'name': $translate.instant('CREATED_AT_TYPE'),
                'key': 'created_at'
            }
        ];

        // Initialize order payment types
        $scope.orderPaymentTypes = [
            {
                name: $translate.instant('ONLINE_PAYMENT_ORDER'),
                value: 'online'
            },
            {
                name: $translate.instant('OFFLINE_PAYMENT_ORDER'),
                value: 'offline'
            }
        ];

        $scope.getCities = function () {
            $http.get('api/filter/cities', {
                ignoreLoadingBar: true
            }).then(function (response) {
                $rootScope.filterCities = response.data.cities;
            });
        };

        $scope.getDistricts = function (city) {
            $rootScope.filterDistricts = [];
            city.forEach(element => {
                var find = $rootScope.filterCities.findIndex(function (item) {
                    return element == item.name;
                })
                if (find > -1) {
                    $rootScope.filterDistricts = [...$rootScope.filterDistricts, ...$rootScope.filterCities[find].districts];
                }
            });
            setTimeout(() => {
                $('.selectpicker').selectpicker('refresh');
            }, 100);
        };

        $scope.refreshData = function (page) {
            $scope.$broadcast('refresh_data');
        };

        $scope.selectAllOrder = function (select) {
            if (select) {
                // $scope.selectedItems = [];
                // for (let i = 0; i < $scope.data.orders.data.length; i++) {
                //     if (!$scope.data.orders.data[i].status) {
                //         // if ($scope.data.orders.data[i].status.id !== $scope.data.success.id && $scope.data.orders.data[i].status.id !== $scope.data.fail.id) {
                //             $scope.selectedItems.push($scope.data.orders.data[i].id);
                //         // }
                //     } else {
                //         // $scope.selectedItems.push($scope.data.orders.data[i].id);
                //     }
                // }
                $scope.filterData.selectall = true;
                $scope.customerOrders()

            } else {
                $scope.selectedItems = [];
            }
        };
        $scope.selectAllOrderCheck = function (select) {
            if (select) {
                $scope.selectedItems = [];
                for (let i = 0; i < $scope.data.orders.data.length; i++) {
                    console.log($scope.data.orders.data[i])
                    $scope.selectedItems.push($scope.data.orders.data[i].id);
                }
            } else {
                $scope.selectedItems = [];
            }
        };


        $scope.addSelectedItem = function (item) {
            if ($scope.selectedItems.indexOf(item) > -1) {
                $scope.selectedItems.splice($scope.selectedItems.indexOf(item), 1);
            } else {
                $scope.selectedItems.push(item);
            }
        };

        $scope.checklistOpts = {
            autoApply: false,
            minDate: moment(),
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Done",
                cancelLabel: "",
                fromLabel: "From",
                toLabel: "/",
                format: "MM/DD/YY",
                customRangeLabel: 'Ozel Aralık'
            },
            ranges: {
                // 'All': [moment().subtract(2, 'years'), moment().add(2, 'years')],
                'Today': [moment(), moment()],
                'Tomorrow': [moment().add(1, 'days'), moment().add(1, 'days')]
            }
        }

        $scope.filterData = {
            customers: [],
            workers: [],
            workSteps: [],
            workTypes: [],
            city: [],
            district: [],
            order_payment: [],
            source: [],
            term: '',
            page: 1,
            paginate: 25,
            stations: [],
            created_at: {
                startDate: null,
                endDate: null
            },
            scheduled_time: {
                startDate: null,
                endDate: null
            }
        }

        $scope.addFilterProps = function (item) {
            if ($scope.filterProp.indexOf(item) === -1)
                $scope.filterProp.push(item);
            else {
                var index = $scope.filterProp.indexOf(item);
                $scope.filterProp.splice(index, 1);
                if (item != 'term') {
                    $scope.filterData[item] = [];
                } else {
                    $scope.filterData[item] = "";
                }
                if (item == 'date') {
                    delete $scope.filterData.startDate;
                    delete $scope.filterData.endDate;
                }
                if ($scope.filterProp.length == 0) {
                    $scope.filter('clear');
                }
            }
        }

        $scope.getPage = function (page) {
            $scope.filterData.page = page;
            $scope.filter();
        }

        $scope.sort = function (field, sort) {
            $scope.filterData.field = field;
            $scope.filterData.sort = sort;
            $scope.filter();
        }

        $scope.filter = function (type) {
            if (type == 'clear') {
                $scope.filterData = {
                    customers: [],
                    workers: [],
                    workSteps: [],
                    workTypes: [],
                    city: [],
                    district: [],
                    order_payment: [],
                    source: [],
                    term: '',
                    paginate: 25,
                    page: 1,
                    stations: [],
                    created_at: {
                        startDate: null,
                        endDate: null
                    },
                    scheduled_time: {
                        startDate: null,
                        endDate: null
                    }
                }
                $scope.filterProp = [];
            } else {
                $scope.filterData.filterProp = $scope.filterProp;
                if (typeof $scope.filterData.created_at.endDate !== 'undefined' && $scope.filterData.created_at.endDate !== null) {
                    $scope.filterData.filterProp.created_at = 'created_at';
                }
                if (typeof $scope.filterData.scheduled_time.endDate !== 'undefined' && $scope.filterData.scheduled_time.endDate !== null) {
                    $scope.filterData.filterProp.scheduled_time = 'scheduled_time';
                }
            }
            $scope.customerOrders();
        }

        $scope.clearFilter = function (page) {
            $scope.filterData = {
                customers: [],
                workers: [],
                workSteps: [],
                workTypes: [],
                city: [],
                district: [],
                order_payment: [],
                source: [],
                term: '',
                paginate: 25,
                page: 1,
                stations: [],
                created_at: {
                    startDate: null,
                    endDate: null
                },
                scheduled_time: {
                    startDate: null,
                    endDate: null
                }
            }
            $location.search('data', null)
            $scope.filterProp = ['customers']; // Müşteri filtresini varsayılan olarak göster
            $scope.customerOrders('map');
        }

        $scope.$on('refresh_data', function () {
            console.log('refreshing map...')
            $scope.customerOrders();
        }, true);

        $scope.searchOrder = function (term) {
            $scope.filterData.term = term;
            $scope.customerOrders();
        }

        $scope.exportCustomerExcel = function () {
            $scope.filterData.export = true;
            CustomerOrder.customerOrders($scope.filterData).success(function (data, status, headers, config) {
                window.location.href = data['url'];
                delete $scope.filterData.export;
            });

            // Order.generateExcelReport($scope.filterData).success(function(data, status, headers, config) {
            //     setTimeout(function(){
            //         Order.removeDownloadFile({path: data['path']}).success(function(response, status, headers, config) { 
            //             $scope.selectedItem = [];
            //         });
            //     },2000)

            // });
        };

        $scope.customerOrders = function () {
            // Müşteri listesini yükle
            $scope.getCustomers();
            
            if ($routeParams.invoice_id) {
                $scope.filterData.invoice_id = $routeParams.invoice_id;
            }
            if (IsJsonString($routeParams.data)) {
                filter = JSON.parse($routeParams.data);
                if (typeof filter == 'object') {
                    angular.merge($scope.filterData, filter);
                }
            }
            if ($routeParams.real_order) {
                $scope.filterData.real_order = true;
                $rootScope.realOrder = true;
            } else {
                $rootScope.realOrder = false;
            }
            if ($routeParams.order_id) {
                $scope.getOrderDetails($routeParams.order_id);
			}
            CustomerOrder.customerOrders($scope.filterData).success(function (data, status, headers, config) {
                // DEBUG: Customer Orders API Response
                console.log('=== CUSTOMER ORDERS DEBUG ===');
                console.log('Full Response:', data);
                console.log('Source Filters:', data.source_filters);
                console.log('=============================');
                
                if ($scope.filterData.selectall) {
                    $scope.selectedItems = data.orders;
                    delete $scope.filterData.selectall;
                    return true;
                }
                $scope.data = data;
                if($rootScope.realOrder) {
                    $scope.data.steps.unshift({
                        id : 0,
                        name : 'Oluşturuldu'
                    });
                }
                $scope.data.stations.unshift({
                    id: 0,
                    code: 'All'
                });

                if (data.orders.data.length === 0) {
                    $scope.isEmpty = true;
                } else {
                    $scope.isEmpty = false;
                }
            });
        };

        $scope.getReaminingTime = function (item) {
            if (!item.estimated_delivery) {
                CustomerOrder.getReaminingTime(item.id).success(function (data, status, headers, config) {
                    item.estimated_delivery = data.estimated_delivery;
                });
            }
        };

        $scope.removeNotDelivery = function () {
            CustomerOrder.removeNotDelivery().success(function (data, status, headers, config) {
                $scope.data.not_delivery_zone = null;
            });
        };

        $scope.downloadZip = function () {
            Order.generateTotalOrdersReportInZip({
                orders: $scope.selectedItems
            }).success(function (data, status, headers, config) {
                window.location.href = data['url'];
                setTimeout(function () {
                    Order.removeDownloadFile({
                        path: data['path']
                    }).success(function (response, status, headers, config) {
                        $scope.selectedItems = [];
                    });
                }, 2000)
            });
        };


        $scope.deleteOrders = function (send_cancel_sms) {
            Order.deleteOrders({
                orders: $scope.selectedItems,
                send_cancel_sms: send_cancel_sms
            }).success(function (response, status, headers, config) {
                $scope.customerOrders();
                $scope.selectedItems = [];
                $('#deleteOrdersModal').modal('toggle');
            });
        };

        $scope.getCustomerOrderDetails = function (work) {
            $rootScope.loadingWork = true;
            // Eğer work bir obje ise, id'sini al; değilse work'un kendisini kullan
            var id = typeof work === 'object' ? work.id : work;
            
            if (id) {
                CustomerOrder.customerOrder(id).success(function (data, status, headers, config) {
                    $rootScope.loadingWork = false;
                    $rootScope.selectedWork = data.order;
                    setTimeout(() => {
                        $scope.$apply();
                    }, 300);
                    $('#orderDetail').modal('show');
                });
            } else {
                $rootScope.loadingWork = false;
            }
        }

        $scope.report = function (type) {
            Analytic.customerOrders($scope.filterData).success(function (data, status, headers, config) {
                $scope.data = data;
                $scope.series = ['Tamamlanan', 'Bekleyen', 'Başarısız', 'Toplam'];
                $scope.chartColors = [
                    '#7209b7',
                    '#4a5157',
                    '#c93b2b',
                    '#7209b7'
                ];
                $scope.barChartData = [
                    data.chart.count.success,
                    data.chart.count.other,
                    data.chart.count.fail,
                    data.chart.count.total
                ];
                $scope.chartData = [data.count.success, data.count.other, data.count.fail, data.count.total];
                $('#reportModal').modal('show');
            });
        };

        $scope.selectDate = {
            page: 1,
            created_at: {
                startDate: moment(),
                endDate: moment()
            }
        }

        $scope.optsCheckOrder = {
            date: {
                startDate: moment(),
                endDate: moment()
            }
        };

        $scope.checkOrder = function (id) {
            $('#checkboxDefault-' + id).prop("disabled", true).closest('tr').addClass('checked');
            CustomerOrder.checkOrder({
                id: id
            }).success(function (data, status, headers, config) {
                Messenger().post(data.message);
            });
        };

        $scope.$watchCollection('filterData.scheduled_time', function () {
            $scope.refreshData('map');
        });

        $scope.selectedDate = 'All';
        $scope.setDate = function (date) {
            $scope.selectedDate = date;
            $scope.filterData.weekDay = date;
            $scope.filterData.checklist = true;
            $scope.filterData.no_paginate = true;
            $scope.filterData.stations = [0];

            setTimeout(() => {
                $('.selected-item').click();
                $('.filter-option').html($translate.instant('BY_STATION'))
            }, 1000);
        }

        $scope.clearCheckFilter = function (page) {
            $scope.filterData = {
                customers: [],
                workers: [],
                workSteps: [],
                workTypes: [],
                city: [],
                district: [],
                order_payment: [],
                source: [],
                term: '',
                paginate: 25,
                page: 1,
                stations: [],
                checklist: true,
                created_at: {
                    startDate: null,
                    endDate: null
                },
                scheduled_time: {
                    startDate: null,
                    endDate: null
                }
            }
            $('.selectpicker').selectpicker('val', []);
            $location.search('data', null)
            $scope.filterProp = ['customers']; // Müşteri filtresini varsayılan olarak göster
            $scope.customerOrders('map');
        }

        $scope.getIkasOrders = function () {
            if (!$scope.filterData.ikasIds.length) {
                alert('Lütfen IKAS Sipariş Numarası Giriniz!');
                return;
            }
            $rootScope.loadingWork = true;
            CustomerOrder.getIkasOrder({ ids: $scope.filterData.ikasIds }).success(function (data, status, headers, config) {
                $scope.customerOrders();
                $scope.filterData.ikasIds = [];
                $rootScope.loadingWork = false;
                Messenger().post(data.message);
                $('#IkasOrderIdModal').modal('toggle');
            });
        };

        $scope.getOrderDetails = function (orderId) {
            // Eğer orderId bir obje ise, id'sini al
            var id = typeof orderId === 'object' ? orderId.id : orderId;
            
            if (id) {
                CustomerOrder.customerOrder(id).success(function (data, status, headers, config) {
                    $rootScope.selectedWork = data.order;
                    $('#orderDetail').modal('show');
                });
            }
        };

        function IsJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

    }
]);